import { NumberField } from 'payload'
import { MaskedFieldOptions } from '@components/(payload)/fields/text/masked'
import { addCellComponent, FieldDefault, FieldWithouType, maskedField } from '@utils/fields'
import { mergeObjects } from '@utils/objects'

export const currencyMaskOptions: MaskedFieldOptions = {
  mask: 'R$ num',
  lazy: false,
  blocks: {
    num: {
      mask: 'number',
      thousandsSeparator: '.',
      radix: ',',
      scale: 2,
      min: 0,
      autofix: true,
      padFractionalZeros: true,
    }
  }
};

export const currencySignedMaskOptions: MaskedFieldOptions = {
  mask: 'R$ num',
  lazy: false,
  blocks: {
    num: {
      mask: 'number',
      thousandsSeparator: '.',
      radix: ',',
      scale: 2,
      autofix: true,
      padFractionalZeros: true,
    }
  }
};

/**
 * Creates a NumberField (payload-better-fields-plugin) for currency
 *
 * @param overrides
 * @param config
 * @returns
 */
export function currencyField(config: FieldWithouType<CustomPayloadField<NumberField>>, options?: MaskedFieldOptions): CustomPayloadField<NumberField>[] {
  const defaultConfig: FieldDefault<CustomPayloadField<NumberField>> = {
    type: 'number',
    defaultValue: 0,
    admin: {
      exportable: {
        format: 'currency',
      }
    }
  };

  config = mergeObjects(defaultConfig, config);
  options = mergeObjects(currencyMaskOptions, options || {});

  const field = addCellComponent<CustomPayloadField<NumberField>>(config as NumberField, 'currency')[0];
  return maskedField<CustomPayloadField<NumberField>>(field, options);
}
